export default "__VITE_ASSET__CpI4clh___"